import BaseClient from '@/app/model/api/response/baseApiClient'

class WeatherApi extends BaseClient {
  public getWeatherData (fieldId: string) {
    const path = '/v1/field/weathers/' + fieldId
    const url = new URL(process.env.VUE_APP_API_URL + path)

    const body: any = super.buildRequestBodyIfNeeded('GET')
    return fetch(decodeURI(url.href), body)
      .then(response => { return response.json() })
      .then(data => super.getPayload(data))
      .catch(e => super.doError(e))
  }
}

export default new WeatherApi()
